import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const NavItem = ({ label, path, onClick }) => {
  return (
    <li className="px-4 py-2 font-semibold transition-colors duration-200">
      <NavLink
        to={path}
        onClick={onClick}
        className={({ isActive }) =>
          `block w-full h-full text-2xl ${
            isActive ? 'text-green-700' : 'text-gray-600 hover:text-blue-500'
          }`
        }
      >
        {label}
      </NavLink>
    </li>
  );
};

NavItem.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NavItem;
